// feature/tipo-taxonomy — hierarchical tipo de actuación taxonomy.
// Sub-types are sourced from Tania's May 2026 team meeting feedback.
// Existing cases (created before the migration) leave sub_tipo NULL and
// fall back to displaying just the tipo label.
//
// feature/taxonomy-cleanup (post-meeting). Per Angie:
//   • Desacatos: consolidated to apertura / cierre / escrito_incidente.
//   • Sanciones: consolidated to apertura / cierre / no_vincula_previsora.
//   • Requerimientos: escrito_incidente vs auto.
//   • Fallos: added 'nulidad' for the case_type_data.tipo_fallo enum extension
//     (handled at display level only here; the DB-level enum bump lands as
//     a Sprint 51 follow-up since case_type_data has its own CHECK).
export const CASE_TAXONOMY = {
  tutela: {
    label: "Tutela",
    sub_tipos: [],
    has_no_aplica_flag: true,
  },
  fallo: {
    label: "Fallo",
    sub_tipos: [
      { value: "primera_favorable",     label: "Fallo primera instancia — Favorable",    instancia: "primera", resultado: "favorable" },
      { value: "primera_desfavorable",  label: "Fallo primera instancia — Desfavorable", instancia: "primera", resultado: "desfavorable" },
      { value: "segunda_favorable",     label: "Fallo segunda instancia — Favorable",    instancia: "segunda", resultado: "favorable" },
      { value: "segunda_desfavorable",  label: "Fallo segunda instancia — Desfavorable", instancia: "segunda", resultado: "desfavorable" },
      { value: "nulidad",               label: "Fallo nulidad",                          instancia: null,      resultado: "nulidad" },
    ],
  },
  requerimiento: {
    label: "Requerimiento",
    sub_tipos: [
      { value: "escrito_incidente", label: "Escrito de incidente (acccionante envió, juez no decidió)" },
      { value: "auto",              label: "Auto (juez ya emitió)" },
    ],
  },
  desacato: {
    label: "Desacato",
    sub_tipos: [
      { value: "apertura",          label: "Apertura" },
      { value: "cierre",            label: "Cierre" },
      { value: "escrito_incidente", label: "Escrito de incidente" },
    ],
  },
  sancion: {
    label: "Sanción",
    sub_tipos: [
      { value: "apertura",              label: "Apertura" },
      { value: "cierre",                label: "Cierre" },
      { value: "no_vincula_previsora",  label: "No vincula a Previsora" },
    ],
  },
  consulta: {
    label: "Consulta",
    sub_tipos: [],
  },
};

// Display-friendly labels for the consolidated sub_tipo values.
export const TIPO_DISPLAY = {
  apertura:                "Apertura",
  cierre:                  "Cierre",
  escrito_incidente:       "Escrito de incidente",
  auto:                    "Auto",
  no_vincula_previsora:    "No vincula a Previsora",
  favorable:               "Favorable",
  desfavorable:            "Desfavorable",
  nulidad:                 "Nulidad",
};

export const TIPO_VALUES = Object.keys(CASE_TAXONOMY);

// Render the full hierarchical label for a case row.
export function formatTipo(tipo, sub_tipo, no_aplica) {
  const t = CASE_TAXONOMY[tipo];
  if (!t) return tipo || "—";
  if (no_aplica) return `${t.label} (N/A)`;
  if (sub_tipo) {
    const s = t.sub_tipos.find(x => x.value === sub_tipo);
    if (s) return s.label;
  }
  return t.label;
}

// Resolve a sub_tipo selection into instancia + resultado side-effects (fallo only).
export function deriveFalloFields(sub_tipo) {
  const s = (CASE_TAXONOMY.fallo.sub_tipos || []).find(x => x.value === sub_tipo);
  if (!s) return { instancia: null, resultado: null };
  return { instancia: s.instancia || null, resultado: s.resultado || null };
}
